import template from './employee_view_systems_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewSystemComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee = ko.observable();
		this.employee_id = ko.observable();
		this.systems = ko.observableArray();
		this.logged_in_employee_id = Utils.current_employee_id();
		this.user_access_roles = ko.observableArray();

		if (this.bindings.employee && ko.isObservable(this.bindings.employee))
		{
			this.bindings.employee.subscribe((nv) => {
				if (nv)
				{
					this.employee(nv);
					this.employee_id(nv.employee_id);
					this.loadPage();
				}
			});
		}

		if (this.bindings.employee_id && ko.isObservable(this.bindings.employee_id))
			this.bindings.employee_id.subscribe((nv) => { 
				this.employee_id(nv); 
			});
	}

	async loadPage()
	{
		// systems
		if (this.employee_id())
		{
			let res = await Grape.fetches.getJSON('/employee/' + this.employee_id() + '/all_systems', {});
			if (res.status == 'OK')
			{
				for (let a = 0; a < res.systems.length; a++)
				{
					if (res.systems[a].approved == null || res.systems[a].approved == undefined)
						res.systems[a].approved = false;
				}

				this.systems(res.systems);
			}

			let result = await Grape.fetches.getJSON('/settings/get_user_access_roles_by_employee_id', {employee_id: this.employee_id()}); 

			if (result.status !== 'ERROR')
				this.user_access_roles(result.roles); 
		}
	};

	async add_to_system(data)
	{
		let value = ko.toJS(data);
		value.employee_id = this.employee_id();

		let res = await Grape.fetches.postJSON('/employee/add_to_system', value)
		
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Successfully added to System.'), title: tr('Success', 'Success') });
			this.loadPage();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error') });
	};

	async remove_from_system(data)
	{
		let value = ko.toJS(data);
		value.employee_id = this.employee_id();

		/* API or function to remove employee from system comes here */

		let res = await Grape.fetches.postJSON("/employee_system/remove", value);
		
		if (res)
		{
			if(res.status == "OK")
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully removed from system.'), title: tr('Successfully') })
				this.loadPage();
			}
			else
				Grape.alerts.alert("Something went wrong...");
		} 
	};
}

export default {
	name: 'employee_view_systems_component',
	viewModel: EmployeeViewSystemComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_systems_component'
};
